import posthog, { type CaptureOptions } from "posthog-js";

const DEBOUNCED_EVENTS_MAP = new Map<string, NodeJS.Timeout>();

export function trackEvent(
  name: string,
  properties?: Record<string, string>,
  options?: CaptureOptions,
) {
  posthog.capture(name, properties, options);
}

export function trackEventDebounced(
  name: string,
  properties?: Record<string, string>,
  debounceMs: number = 1000,
) {
  const existingTimeout = DEBOUNCED_EVENTS_MAP.get(name);
  if (existingTimeout) {
    clearTimeout(existingTimeout);
  }

  // Set new timeout
  const timeout = setTimeout(() => {
    trackEvent(name, properties);
    DEBOUNCED_EVENTS_MAP.delete(name);
  }, debounceMs);

  DEBOUNCED_EVENTS_MAP.set(name, timeout);
}
